export enum OtpStep {
    EMAIL = 'email',
    TOKEN = 'token',
}
